import PropTypes from 'prop-types'

function ShowTotal({ orders, total }) {
  return (
    <div>
      <b>Showing</b>: {orders.length}
      {' | '}
      <b>Total</b>: {total} {total || 0 > 1 ? 'orders' : 'order'}.
    </div>
  )
}

ShowTotal.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
}

export default ShowTotal
